import { render, staticRenderFns } from "./activetemplateType.vue?vue&type=template&id=dc2968fe"
import script from "./activetemplateType.vue?vue&type=script&lang=js"
export * from "./activetemplateType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports